<script lang="ts" setup>
import { UIButton } from '@gohighlevel/ghl-ui'
import { PropType, useSlots } from 'vue'

type Type = 'secondary' | 'primary' | 'error' | 'tertiary' | 'text'
type Size = 'small' | 'medium' | 'large'

defineProps({
  id: {
    type: String,
    required: true,
  },
  buttonType: {
    type: String as PropType<Type>,
    default: 'primary',
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  quaternary: {
    type: Boolean,
    default: false,
  },
  circle: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String as PropType<Size>,
    default: 'medium',
  },
  capitalize: {
    type: Boolean,
    default: false,
  },
})
const slots = useSlots()

defineEmits(['click'])
</script>
<template>
  <UIButton
    :id="id"
    type="tertiary"
    :disabled="disabled"
    :loading="loading"
    :quaternary="quaternary"
    :circle="circle"
    class="h-12"
    :class="{
      'community-button-primary': buttonType === 'primary',
      'community-button-secondary': buttonType === 'secondary',
      'community-button-tertiary': buttonType === 'tertiary',
      'community-button-error': buttonType === 'error',
      uppercase: capitalize,
    }"
    @click="e => $emit('click', e)"
  >
    <slot />
    <slot v-if="slots.icon" name="icon"
  /></UIButton>
</template>
<style scoped>
.community-button-primary {
  --n-color: var(--primary) !important;
  --n-color-hover: var(--primaryDark) !important;
  --n-color-pressed: var(--primaryDark) !important;
  --n-color-focus: var(--primaryDark) !important;
  --n-color-disabled: var(--primaryLight) !important;
  --n-ripple-color: var(--primary) !important;
  --n-border: 0px !important;
  --n-border-hover: 0px !important;
  --n-border-pressed: 0px !important;
  --n-border-focus: 0px !important;
  --n-border-disabled: 0px !important;
  --n-text-color: var(--sidebar-selected-item-font) !important;
  --n-text-color-hover: var(--sidebar-selected-item-font) !important;
  --n-text-color-pressed: var(--sidebar-selected-item-font) !important;
  --n-text-color-focus: var(--sidebar-selected-item-font) !important;
  --n-text-color-disabled: var(--sidebar-selected-item-font) !important;
}
.community-button-secondary {
  --n-color: var(--sidebar-selected-item) !important;
  --n-color-hover: var(--secondaryDark) !important;
  --n-color-pressed: var(--secondaryDark) !important;
  --n-color-focus: var(--secondaryDark) !important;
  --n-color-disabled: var(--secondaryLight) !important;
  --n-ripple-color: var(--secondaryDark) !important;
  --n-border: 0px !important;
  --n-border-hover: 0px !important;
  --n-border-pressed: 0px !important;
  --n-border-focus: 0px !important;
  --n-border-disabled: 0px !important;
  --n-text-color: var(--sidebar-selected-item-font) !important;
  --n-text-color-hover: var(--sidebar-selected-item-font) !important;
  --n-text-color-pressed: var(--sidebar-selected-item-font) !important;
  --n-text-color-focus: var(--sidebar-selected-item-font) !important;
  --n-text-color-disabled: var(--sidebar-selected-item-font) !important;
}
.community-button-tertiary {
  --n-color: var(--background) !important;
  --n-color-hover: var(--background) !important;
  --n-color-pressed: var(--background) !important;
  --n-color-focus: var(--background) !important;
  --n-color-disabled: var(--background) !important;
  --n-ripple-color: var(--background) !important;
  --n-border: var(--border-style) var(--border) !important;
  --n-border-hover: var(--border-style) var(--border) !important;
  --n-border-pressed: var(--border-style) var(--border) !important;
  --n-border-focus: var(--border-style) var(--border) !important;
  --n-border-disabled: var(--border-style) var(--border) !important;

  --n-text-color: var(--fontSecondary) !important;
  --n-text-color-hover: var(--fontPrimary) !important;
  --n-text-color-pressed: var(--fontPrimary) !important;
  --n-text-color-focus: var(--fontPrimary) !important;
  --n-text-color-disabled: var(--border) !important;
}
.community-button-error {
  --n-color: var(--error) !important;
  --n-color-hover: var(--errorDark) !important;
  --n-color-pressed: var(--errorDark) !important;
  --n-color-focus: var(--errorDark) !important;
  --n-color-disabled: var(--errorLight) !important;
  --n-ripple-color: var(--error) !important;
  --n-border: 0px !important;
  --n-border-hover: 0px !important;
  --n-border-pressed: 0px !important;
  --n-border-focus: 0px !important;
  --n-border-disabled: 0px !important;
  --n-text-color: var(--sidebar-selected-item-font) !important;
  --n-text-color-hover: var(--sidebar-selected-item-font) !important;
  --n-text-color-pressed: var(--sidebar-selected-item-font) !important;
  --n-text-color-focus: var(--sidebar-selected-item-font) !important;
  --n-text-color-disabled: var(--sidebar-selected-item-font) !important;
}
</style>
